module.exports = "/_next/static/images/a17afc3f165f77964334f9a264dbe9c5-pregnant-woman@mobile@2x.jpg";